<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div v-else>
            <div class="top-right-button-container">
                <b-button-group class="mb-2">
                    <b-dropdown size="sm" variant="outline-primary" right :text="'Actions'">
                        <b-dropdown-item @click="facilityComment" size="sm" variant="outline-primary">
                            Add Comment
                        </b-dropdown-item>
                        <b-dropdown-item @click="facilityContract" size="sm" variant="outline-primary">
                            Add Contract
                        </b-dropdown-item>
                    </b-dropdown>

                    <b-button @click="facilityStatus" size="sm" variant="outline-primary">
                        Change Status
                    </b-button>

                    <b-dropdown size="sm" variant="primary" right text="More">
                        <b-dropdown-item @click="assignStaff(facility.facility_id)">Assign Staff</b-dropdown-item>

                        <b-dropdown-divider/>

                        <b-dropdown-item @click="editFacility(facility.facility_id)">Edit</b-dropdown-item>

                        <b-dropdown-item @click="deleteFacility(facility)">Delete</b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
            </div>

            <div class="d-flex flex-row mb-4">
                <span class="iconsminds-building mr-3 menu-icon-style" style="font-size: 23px;"/>

                <piaf-breadcrumb :heading="facility.data.attributes.code + ' - ' +facility.data.attributes.name"/>

<!--                <p class="my-auto">-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                    repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                    officiis quia quos rem totam vitae.-->
<!--                </p>-->
            </div>

            <b-tabs nav-class="separator-tabs ml-0 mb-4" content-class="tab-content" :no-fade="true">
                <b-tab title="SUMMARY" @click="getSummary" :active="$route.name === 'facilities.show'">
                    <b-row>
                        <b-colxx xxs="12" lg="4">
                            <b-card no-body>
                                <b-card-body>
                                    <div class="mt-md-5">
                                        <span class="card-subtitle text-one">Summary of</span><br>

                                        <h4 class="bold">{{facility.data.attributes.name}}</h4>

                                        <b-badge pill class="position-absolute badge-top-left"
                                                 :variant="facilityStatusColor(facility.data.attributes.status)">
                                            {{ facility.data.attributes.code + ' | ' + facility.data.attributes.status }}
                                        </b-badge>

                                        <b-badge variant="secondary" pill class="position-absolute badge-top-left-2">
                                            {{ facility.data.attributes.vendor }}
                                        </b-badge>
                                    </div>
                                </b-card-body>

                                <div class="position-relative">
                                    <img src="/default/facility_profile_pic.jpg" alt="Detail" class="card-img-top"/>
                                </div>

                                <b-card-body>
                                    <h4 class="mb-4">Details</h4>

                                    <p>
                                        <ListForSummary :icon="'iconsminds-shuffle-3'" :title="'Type'"
                                                        :border-bottom="true" :content="facility.data.attributes.type"/>

                                        <ListForSummary :icon="'iconsminds-geo2--'" :title="'Address'"
                                                        :border-bottom="true"
                                                        :content="facility.data.attributes.address"/>

                                        <ListForSummary :icon="'iconsminds-male-female'" :title="'Contact Name'"
                                                        :border-bottom="true"
                                                        :content="facility.data.attributes.contact"/>

                                        <ListForSummary :icon="'iconsminds-mail-with-at-sign'" :title="'Email'"
                                                        :border-bottom="true"
                                                        :content="facility.data.attributes.email"/>

                                        <ListForSummary :icon="'iconsminds-smartphone-4'" :title="'Phone'"
                                                        :border-bottom="true"
                                                        :content="facility.data.attributes.phone"/>

                                        <ListForSummary :icon="'iconsminds-calendar-4'"
                                                        :title="'Started with HASA'"
                                                        :border-bottom="true"
                                                        :content="facility.data.attributes.start_hasa"/>

                                        <ListForSummary :icon="'iconsminds-calendar-4'" :title="'Started with EHP'"
                                                        :border-bottom="true"
                                                        :content="facility.data.attributes.start_ehp"/>

                                        <ListForSummary :icon="'iconsminds-handshake'" :title="'Current Contract Period'"
                                                        :border-bottom="true"
                                                        :content="this.facility.data.attributes.contract"/>

                                        <ListForSummary :icon="'iconsminds-id-card'" :title="'EIN'"
                                                        :border-bottom="true" :content="facility.data.attributes.ein"/>

                                        <ListForSummary :icon="'iconsminds-dollar-sign-2'" :title="'Rate'"
                                                        :border-bottom="true"
                                                        :content="facility.data.attributes.rate"/>

                                        <ListForSummary :icon="'iconsminds-calendar-4'"
                                                        :title="'No. of Units As Per Contract'"
                                                        :content="facility.data.attributes.total_units"/>
                                    </p>

                                    <div class="mb-2">
                                        <b-badge pill class="mr-1"
                                                 :variant="facility.data.attributes.medicine === 'Yes' ? 'info' : 'warning'"
                                                 :class="facility.data.attributes.medicine === 'No' ? 'faa-horizontal animated' : ''">
                                            Medicine | {{facility.data.attributes.medicine}}
                                        </b-badge>

                                        <b-badge pill class="mr-1"
                                                 :variant="facility.data.attributes.smoke_free === 'Yes' ? 'info' : 'warning'"
                                                 :class="facility.data.attributes.smoke_free === 'No' ? 'faa-horizontal animated' : ''">
                                            Smoke Free | {{facility.data.attributes.smoke_free}}
                                        </b-badge>
                                    </div>

                                    <div class="mb-2">
                                        <b-badge pill class="mr-1"
                                                 :variant="facility.data.attributes.elevator === 'Yes' ? 'info' : 'warning'"
                                                 :class="facility.data.attributes.elevator === 'No' ? 'faa-horizontal animated' : ''">
                                            Elevator | {{facility.data.attributes.elevator}}
                                        </b-badge>

                                        <b-badge pill class="mr-1"
                                                 :variant="facility.data.attributes.handicap_access === 'Yes' ? 'info' : 'warning'"
                                                 :class="facility.data.attributes.handicap_access === 'No' ? 'faa-horizontal animated' : ''">
                                            Handicap Access | {{facility.data.attributes.handicap_access}}
                                        </b-badge>
                                    </div>

                                    <div class="mb-3">
                                        <b-badge pill variant="outline-info" class="mr-1">
                                            Units Active | {{ stats.data.attributes.active_units.count }}
                                        </b-badge>

                                        <b-badge pill variant="outline-info" class="mr-1">
                                            Units Inactive | {{ stats.data.attributes.inactive_units.count }}
                                        </b-badge>
                                    </div>

                                    <p class="text-muted text-small mb-2">Notes</p>

                                    <p>{{facility.data.attributes.notes}}</p>
                                </b-card-body>
                            </b-card>
                        </b-colxx>

                        <b-colxx xxs="12" lg="8">
                            <b-alert :show="contract.expired" :variant="contract.variant" dismissible><b>Attention! </b>
                                {{ contract.message }}
                            </b-alert>

                            <b-row class="mb-4">
                                <b-colxx xxs="4">
                                    <radial-progress-card
                                        :title="'Occupied | ' + stats.data.attributes.occupied_units.count"
                                        secondary-title="Total"
                                        :percent="stats.data.attributes.occupied_units.percentage"
                                        no-suffle=""/>
                                </b-colxx>

                                <b-colxx xxs="4">
                                    <radial-progress-card
                                        :title="'Vacant | ' + stats.data.attributes.vacant_units.count"
                                        secondary-title="Total"
                                        :percent="stats.data.attributes.vacant_units.percentage"
                                        no-suffle=""/>
                                </b-colxx>

                                <b-colxx xxs="4">
                                    <radial-progress-card
                                        :title="'Inspections | ' + stats.data.attributes.total_inspections.count"
                                        secondary-title="Total"
                                        :percent="stats.data.attributes.total_inspections.percentage"
                                        no-suffle=""/>
                                </b-colxx>
                            </b-row>

                            <b-row class="m-0 mb-4 sep-border-bottom">
                                <b-colxx xxs="12" lg="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">Referrals<br>
                                        <small class="text-muted">Total</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.total_referrals.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="12" lg="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">Admissions<br>
                                        <small class="text-muted">Total</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.total_admissions.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="12" lg="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">No-shows<br>
                                        <small class="text-muted">Total</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.total_noshows.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="12" lg="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">Discharges<br>
                                        <small class="text-muted">Total</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.total_discharges.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="12" lg="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">Complaints<br>
                                        <small class="text-muted">Total</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.total_complaints.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="12" lg="2">
                                    <h6 class="mb-n2">Incidents<br>
                                        <small class="text-muted">Total</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.total_incidents.count }}
                                    </span>
                                </b-colxx>
                            </b-row>

                            <b-card v-if="$route.name === 'facilities.show'" class="mb-4">
                                <div class="d-flex flex-row">
                                    <i class="iconsminds-line-chart-3 text-large mb-4 mr-3 menu-icon-style"/>

                                    <div class="my-auto">
                                        <div class="d-inline-block mb-4">
                                            <h5 class="d-inline">BILLINGS</h5>

                                            <span class="text-muted text-small d-block">Last Six Months</span>
                                        </div>
                                    </div>
                                </div>

                                <area-shadow-chart :data="billingChartData" :prefix="'$'" :height="195"/>
                            </b-card>

                            <b-card class="mb-4" no-body>
                                <b-tabs card fade>
                                    <b-tab title="Contracts" active>
                                        <vue-perfect-scrollbar v-if="histories.length > 0" class="scroll histories-list"
                                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                            <ContractsList @edit="editContract" @delete="deleteContract" @view="showContractInfo" :data="contracts"/>
                                        </vue-perfect-scrollbar>

                                        <div v-else>
                                            <p>No contract details found.</p>
                                        </div>
                                    </b-tab>

                                    <b-tab title="Comments">
                                        <vue-perfect-scrollbar v-if="comments.length > 0" class="scroll comments-list"
                                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                            <CommentsList v-for="(comment, index) in comments" :data="comment"
                                                          :key="index" @edit="editComment"
                                                          @delete="deleteComment(comment)"/>
                                        </vue-perfect-scrollbar>

                                        <div v-else>
                                            <p>No comments found.</p>
                                        </div>
                                    </b-tab>

                                    <b-tab title="Assigned Staffs">
                                        <vue-perfect-scrollbar v-if="staff.length > 0" class="scroll comments-list"
                                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                            <b-row class="mt-1">
                                                <b-colxx xxs="12" class="mb-3" v-for="(user,index) in staff"
                                                         :key="index">
                                                    <staff-list-item :key="index" :data="user"
                                                                     @unassign="unassignStaff"/>
                                                </b-colxx>
                                            </b-row>
                                        </vue-perfect-scrollbar>

                                        <div v-else>
                                            <p>No staff found.</p>
                                        </div>
                                    </b-tab>

                                    <b-tab title="Histories">
                                        <vue-perfect-scrollbar v-if="histories.length > 0" class="scroll histories-list"
                                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                            <HistoriesList :data="histories"/>
                                        </vue-perfect-scrollbar>

                                        <div v-else>
                                            <p>No histories found.</p>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </b-card>

                            <template v-if="false"> // map set to hidden
                                <b-card v-if="facility.data.attributes.map !== 'Not Assigned'" no-body>
                                    <GmapMap
                                        :center="facility.data.attributes.map.data.attributes.position"
                                        :zoom="15"
                                        map-type-id="roadmap"
                                        class="map-item"
                                        :options="theme === 'dark' ? mapStyles : {}">

                                        <gmap-marker
                                            :position="facility.data.attributes.map.data.attributes.position"
                                            :clickable="true"
                                            @click="mapInfoOpened = true"/>

                                        <gmap-info-window
                                            @closeclick="mapInfoOpened = false"
                                            :opened="mapInfoOpened"
                                            :position="facility.data.attributes.map.data.attributes.position"
                                            :options="{
                                              pixelOffset: {
                                                width: 0,
                                                height: -35
                                              }
                                            }">

                                            <span v-html="facility.data.attributes.map.data.attributes.info"/>
                                        </gmap-info-window>
                                    </GmapMap>
                                </b-card>
                            </template>
                        </b-colxx>
                    </b-row>
                </b-tab>

                <b-tab title="UNITS" @click="getUnits" :active="$route.name === 'facilities.units'">
                    <router-view v-if="$route.name === 'facilities.units'"/>
                </b-tab>

                <b-tab title="ADMISSIONS" @click="getAdmissions" :active="$route.name === 'facilities.admissions'">
                    <router-view v-if="$route.name === 'facilities.admissions'"/>
                </b-tab>

                <b-tab title="INSPECTIONS" @click="getInspections" :active="$route.name === 'facilities.inspections'">
                    <router-view v-if="$route.name === 'facilities.inspections'"/>
                </b-tab>

                <b-tab title="SIGNATURES" @click="getSignatures" :active="$route.name === 'facilities.signatures'">
                    <router-view v-if="$route.name === 'facilities.signatures'"/>
                </b-tab>

                <b-tab title="BILLINGS" @click="getBillings" :active="$route.name === 'facilities.billings'">
                    <router-view v-if="$route.name === 'facilities.billings'"/>
                </b-tab>

                <b-tab title="COMPLAINTS" @click="getComplaints" :active="$route.name === 'facilities.complaints'">
                    <router-view v-if="$route.name === 'facilities.complaints'"/>
                </b-tab>

                <b-tab title="INCIDENTS" @click="getIncidents" :active="$route.name === 'facilities.incidents'">
                    <router-view v-if="$route.name === 'facilities.incidents'"/>
                </b-tab>

                <b-tab title="FILES" @click="getFiles" :active="$route.name === 'facilities.files'">
                    <router-view v-if="$route.name === 'facilities.files'"/>
                </b-tab>
            </b-tabs>

            <FacilityFormModal :edit="true"
                               @updated="updateData(facility.facility_id)"/>

            <FacilityOtherModal :facility="facility" :edit="editMode" :mode="modalMode" @close="resetOtherModal"
                                @updated="getFacility(facility.facility_id)"/>

            <FacilityContractModal v-if="contract_info && contract_attachments" :contract="contract_info" :attachments="contract_attachments"
                                   @file-deleted="$store.dispatch('fetchFacilityContractAttachments', contract_info.contract_id)"/>

            <FacilityStaffModal :facility="facility" :mode="staffMode" :staff-data="staffData"
                                @updated="getFacility(facility.facility_id)"/>

            <FacilityDeleteModal :mode="delete_mode" :data="other_data" :facility="facility"
                                 @deleted-facility="$router.push('/hms/locations/facilities')"
                                 @deleted-contract="getFacility(facility.facility_id)"
                                 @deleted-comment="getFacility(facility.facility_id)"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {mapStyles} from "../../../../data/mapStyles";
    import moment from 'moment';

    import FacilityFormModal from "./modals/FacilityFormModal";
    import FacilityOtherModal from "./modals/FacilityOtherModal";
    import FacilityContractModal from "./modals/FacilityContractModal";
    import FacilityDeleteModal from "./modals/FacilityDeleteModal";
    import FacilityStaffModal from "./modals/FacilityStaffModal";

    import ListForSummary from "../../../../components/Listing/ListForSummary";
    import RadialProgressCard from '../../../../components/Cards/RadialProgressCard';
    import IconCard from '../../../../components/Cards/IconCard';
    import AreaShadowChart from "../../../../components/Charts/AreaShadow";
    import CommentsList from "../../../../components/Listing/CommentsList";
    import StaffCard from "../../../../components/Cards/StaffCard";
    import HistoriesList from "../../../../components/Listing/HistoriesList";
    import StaffListItem from "../../../../components/Listing/StaffListItem";
    import ContractsList from "../../../../components/Listing/ContractsList";

    export default {
        name: "FacilitySummary",

        components: {
            ContractsList,
            StaffListItem,
            FacilityDeleteModal,
            FacilityOtherModal,
            FacilityContractModal,
            FacilityFormModal,
            FacilityStaffModal,
            HistoriesList,
            StaffCard,
            CommentsList,
            ListForSummary,
            RadialProgressCard,
            IconCard,
            AreaShadowChart,
        },

        data() {
            return {
                loading: true,
                contract_remaining: null,
                modalMode: '',
                staffMode: '',
                staffData: '',
                mapInfoOpened: true,
                mapStyles,
                delete_mode: null,
                other_data: null,
                editMode: false,
            }
        },

        computed: {
            ...mapGetters({
                facility: 'getFacility',
                stats: 'getFacilityStats',
                comments: 'getFacilityComments',
                contracts: 'getFacilityContracts',
                contract_info: 'getFacilityContract',
                contract_attachments: 'getFacilityContractAttachments',
                staff: 'getFacilityStaff',
                histories: 'getFacilityHistories',
                colors: 'getThemeColors',
            }),

            contract() {
                if (this.contract_remaining < 0) {
                    return {
                        expired: true,
                        variant: 'danger',
                        message: 'The contract has expired, please renew!',
                    }
                } else if (this.contract_remaining <= 30) {
                    return {
                        expired: true,
                        variant: 'warning',
                        message: 'The contract will be expired soon, please renew!',
                    };
                } else {
                    return {
                        expired: false,
                        variant: 'success',
                        message: 'Whoa! You\'re safe for now!',
                    };
                }
            },

            billingChartData() {
                let payload = this.stats.data.attributes.billings;

                return {
                    labels: payload.labels,
                    datasets: [{
                        data: payload.data,
                        borderColor: this.colors.themeColor1,
                        pointBackgroundColor: this.colors.foregroundColor,
                        pointBorderColor: this.colors.themeColor1,
                        pointHoverBackgroundColor: this.colors.themeColor1,
                        pointHoverBorderColor: this.colors.foregroundColor,
                        backgroundColor: this.colors.themeColor1_10,
                        pointRadius: 4,
                        pointBorderWidth: 2,
                        pointHoverRadius: 5,
                        fill: true,
                        borderWidth: 2
                    }],
                };
            },
        },

        created() {
            // Check if dark or light theme
            if (localStorage.getItem('theme_selected_color')) {
                this.theme = localStorage.getItem('theme_selected_color').split(".")[0];
            }
        },

        mounted() {
            this.getFacility(this.$route.params.facility_id);
        },

        watch: {
            facility(value) {
                if (value) {
                    let target = moment(value.data.attributes.mou_to, "MM-DD-YYYY");
                    let today = new moment();
                    this.contract_remaining = target.diff(today, 'days');
                }
            },
        },

        methods: {
            async showContractInfo(contract_id) {
                await this.$store.dispatch('fetchFacilityContract', contract_id);
                await this.$store.dispatch('fetchFacilityContractAttachments', contract_id);

                this.$bvModal.show('facility_contract');
            },
            async getFacility(facility_id) {
                await this.$store.dispatch('fetchFacility', facility_id)
                    .catch(() => {
                        this.$router.push('/error');
                    });

                await this.$store.dispatch('fetchFacilityComments', facility_id);

                await this.$store.dispatch('fetchFacilityContracts', facility_id);

                await this.$store.dispatch('fetchFacilityStats', facility_id);

                await this.$store.dispatch('fetchFacilityStaff', facility_id);

                await this.$store.dispatch('fetchFacilityHistories', facility_id);

                return this.loading = false;
            },

            updateData(facility_id) {
                if (this.$route.name === 'facilities.files') {
                    return this.$store.dispatch('fetchFacilityFiles', facility_id);
                }

                this.getFacility(facility_id);
            },

            editFacility(facility_id) {
                this.$store.dispatch('fetchEditFacility', facility_id)
                    .finally(() => {
                        this.$bvModal.show('facility_form');
                    });
            },

            deleteFacility() {
                this.delete_mode = 'facility';

                setTimeout(() => {
                    this.$bvModal.show('facility_delete');
                }, 1);
            },

            editComment(comment_id) {
                this.editMode = true;
                this.modalMode = 'comment';

                this.$store.dispatch('fetchEditFacilityComment', comment_id)
                    .finally(() => {
                        this.$bvModal.show('facility_other');
                    });
            },

            deleteComment(comment) {
                this.other_data = comment;
                this.delete_mode = 'comment';

                setTimeout(() => {
                    this.$bvModal.show('facility_delete');
                }, 1);
            },

            editContract(contract_id) {
                this.editMode = true;
                this.modalMode = 'contract';

                this.$store.dispatch('fetchEditFacilityContract', contract_id)
                    .finally(() => {
                        this.$bvModal.show('facility_other');
                    });
            },

            deleteContract(contract) {
                this.other_data = contract;
                this.delete_mode = 'contract';

                setTimeout(() => {
                    this.$bvModal.show('facility_delete');
                }, 1);
            },

            assignStaff(facility_id) {
                this.staffMode = 'assign';

                setTimeout(() => {
                    this.$bvModal.show('facility_staff');
                }, 1);
            },

            unassignStaff(staff) {
                this.staffMode = 'unassign';
                this.staffData = staff;

                setTimeout(() => {
                    this.$bvModal.show('facility_staff');
                }, 1);
            },

            facilityStatus() {
                this.modalMode = 'status';
                this.$bvModal.show('facility_other');
            },

            facilityComment() {
                this.modalMode = 'comment';

                this.$bvModal.show('facility_other');
            },

            facilityContract() {
                this.modalMode = 'contract';

                this.$bvModal.show('facility_other');
            },

            hideModal(refName) {
                this.$refs[refName].hide();
            },

            getSummary() {
                if (this.$route.name !== 'facilities.show') {
                    this.$router.push({name: 'facilities.show'});
                }
            },

            getUnits() {
                if (this.$route.name !== 'facilities.units') {
                    this.$router.push({name: 'facilities.units'});
                }
            },

            getAdmissions() {
                if (this.$route.name !== 'facilities.admissions') {
                    this.$router.push({name: 'facilities.admissions'});
                }
            },

            getInspections() {
                if (this.$route.name !== 'facilities.inspections') {
                    this.$router.push({name: 'facilities.inspections'});
                }
            },

            getSignatures() {
                if (this.$route.name !== 'facilities.signatures') {
                    this.$router.push({name: 'facilities.signatures'});
                }
            },

            getBillings() {
                if (this.$route.name !== 'facilities.billings') {
                    this.$router.push({name: 'facilities.billings'});
                }
            },

            getComplaints() {
                if (this.$route.name !== 'facilities.complaints') {
                    this.$router.push({name: 'facilities.complaints'});
                }
            },

            getIncidents() {
                if (this.$route.name !== 'facilities.incidents') {
                    this.$router.push({name: 'facilities.incidents'});
                }
            },

            getFiles() {
                if (this.$route.name !== 'facilities.files') {
                    this.$router.push({name: 'facilities.files'});
                }
            },

            facilityStatusColor: status => {
                if (status === 'Active') return 'info'
                else if (status === 'Inactive') return 'danger'
                else if (status === 'Offline') return 'warning'
            },

            resetOtherModal() {
                this.editMode = false;
                this.modalMode = '';
            },
        },
    }
</script>

<style scoped>

</style>
